export default function Footer() {
    return (
        <div
            id="kt_footer"
            className="footer bg-white py-4 d-flex flex-lg-column"
        >
            <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between">
                <div className="text-dark order-2 order-md-1">
                    <span className="text-muted font-weight-bold mr-2">
                        {new Date().getFullYear()}©
                    </span>
                    <a
                        href="http://www.capys.com.br"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-dark-75 text-hover-primary"
                    >
                        Capys IT
                    </a>
                </div>
                <div className="nav nav-dark order-1 order-md-2">
                    <a
                        href="https://atendimento.capys.com.br/login.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nav-link pl-3 pr-0"
                    >
                        Contatos
                    </a>
                </div>
            </div>
        </div>
    );
}
